"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyFunction = exports.useIsomorphicLayoutEffect = exports.canUseDom = exports.createCustomEvent = exports.isWindowDefined = exports.isObjectEmpty = void 0;
const react_1 = require("react");
const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};
exports.isObjectEmpty = isObjectEmpty;
exports.isWindowDefined = typeof window !== 'undefined';
const createCustomEvent = (eventTitle) => {
    if (typeof window.Event === 'function') {
        return new Event(eventTitle);
    }
    const event = document.createEvent('Event');
    event.initEvent(eventTitle, true, true);
    return event;
};
exports.createCustomEvent = createCustomEvent;
exports.canUseDom = Boolean(exports.isWindowDefined && window.document && window.document.createElement);
exports.useIsomorphicLayoutEffect = exports.canUseDom ? react_1.useLayoutEffect : react_1.useEffect;
// eslint-disable-next-line @typescript-eslint/no-empty-function
const emptyFunction = () => { };
exports.emptyFunction = emptyFunction;
